import { useFormStore } from '@/stores/form'
import router from '@/router'
import { useGlobalStore } from '@/stores/global'
import apiHelperService from '@/services'
import client_lookups from '@/assets/json/clientLookups.json'
import useCommonFun from '@/composables/useCommonFun'
import { useAuthStore } from '@/stores/auth'

const initForm = async () => {
  const formStore = useFormStore()
  const globalStore = useGlobalStore()
  const { serviceTransactionId } = globalStore.startedService
  const {
    sponsoredUN = '',
    employeeUN = '',
    administrativeRegionId = '',
    withException = ''
  } = router.currentRoute.value.query
  formStore.extraMap = {
    ...formStore.extraMap,
    visaDuarationMsg: '',
    serviceTransactionId,
    administrativeRegionId,
    sponsoredUN,
    employeeUN,
    ageGreaterThan15: false,
    withException: withException == 'true'
  }
  formStore.draft.request = {
    ...formStore.draft.request,
    changePersonPhotoFlag: 0,
    havePoBox: 0,
    companyName: '',
    manageFields: {}
  }
  if (sponsoredUN) {
    const params = {
      unifiedNumber: sponsoredUN,
      serviceTransactionId: serviceTransactionId
    }
    let res = await apiHelperService.post(`/api/icaRequest/draft/prepareEidaRequestData`, {
      ...params
    })
    if (res) {
      const {
        data: { eidaRequest = {} }
      } = res
      const {
        eidaCardExpiryDate = '',
        identityNumber,
        urgentServiceFlag,
        genderId,
        changePersonPhotoFlag,
        faithId,
        personUnifiedNumber,
        birthCertificateNumber,
        dateOfBirth,
        sponsorRelationshipId,
        motherEnglishName,
        motherArabicName,
        currentNationalityId,
        countryOfBirthId,
        sponsoredBirthEmirateId,
        sponsoredBirthCityId,
        englishPlaceOfBirth,
        arabicPlaceOfBirth,
        religionId,
        maritalStatusId,
        emailAddress,
        professionId,
        transactionReasonId,
        educationLevelCountryId,
        qualificationDescription,
        fileIssueDate,
        fileExpiryDate,
        oldEidaExpiryDate,
        newIdCardDurationId
      } = eidaRequest
      formStore.extraMap.ageGreaterThan15 =
        formStore.draft.request.dateOfBirth &&
        useCommonFun().ageComparison(formStore.draft.request.dateOfBirth, 15, '>=')
      formStore.draft.request = {
        ...formStore.draft.request,
        ...eidaRequest,
        oldEidaExpiryDate: oldEidaExpiryDate || eidaCardExpiryDate,
        userHadTheOldCardOrCopy: 0,
        isFaithExistOnUDB: !!faithId,
        sponsorGenderId: genderId,
        urgentServiceFlag: !!urgentServiceFlag ? 1 : 0,
        priorityId: !!urgentServiceFlag ? 2 : 1,
        changePersonPhotoFlag: !!changePersonPhotoFlag,
        showidentityNumberField: !!identityNumber,
        newIdCardDurationId
      }
      formStore.draft.request.manageFields = {
        ...formStore.draft.request.manageFields,
        isIdentityNumberDisabled: !!identityNumber,
        isUnifiedNumberDisabled: !!personUnifiedNumber,
        isOldEidaExpiryDateDisabled: !!oldEidaExpiryDate,
        isBirthCertificateNumberDisabled: !!birthCertificateNumber,
        isDateOfBirthDisabled: !!dateOfBirth,
        isGenderDisabled: !!genderId,
        isSponsorRelationshipIdDisabled: !!sponsorRelationshipId,
        isEnglishMotherNameDisabled: !!motherEnglishName,
        isArabicMotherNameDisabled: !!motherArabicName,
        isCurrentNationalityIdDisabled: !!currentNationalityId,
        isCountryOfBirthIdDisabled: !!countryOfBirthId,
        isSponsoredBirthEmirateIdDisabled: !!sponsoredBirthEmirateId,
        isSponsoredBirthCityIdDisabled: !!sponsoredBirthCityId,
        isEnglishPlaceOfBirthDisabled: !!englishPlaceOfBirth,
        isArabicPlaceOfBirthDisabled: !!arabicPlaceOfBirth,
        isReligionIdDisabled: !!religionId,
        isMaritalStatusDisabled: !!maritalStatusId,
        isEmailAddressDisabled: !!emailAddress,
        isProfessionIdDisabled: !!professionId,
        isTransactionReasonIdDisabled: !!transactionReasonId,
        isEducationLevelCountryIdDisabled: !!educationLevelCountryId,
        isQualificationDescriptionDisabled: !!qualificationDescription,
        isFileIssueDateDisabled: !!fileIssueDate && serviceTransactionId == 571,
        isFileExpiryDateDisabled: !!fileExpiryDate && serviceTransactionId == 571,
        showChangePhoto: formStore.extraMap.ageGreaterThan15,
        showPersonalPhotoBetaIssue: formStore.extraMap.ageGreaterThan15
      }
      if (personUnifiedNumber && [571, 572].includes(serviceTransactionId)) {
        const result = apiHelperService.get(
          `/api/icaRequest/fingerprint-exemption-requests/search/${personUnifiedNumber}`
        )
      }
    }
  }
}

const initInfo = async () => {
  const formStore = useFormStore()
  const authStore = useAuthStore()
  const res = authStore.isUserEstablishment
    ? await apiHelperService.get(`/api/establishment/info`)
    : await apiHelperService.get(`/api/individual/info`)
  if (res) {
    formStore.draft.request.individualInfo = res
    formStore.extraMap.administrativeRegionId = res.adminRegionId
  }
}

const getEidaDetails = async () => {
  const formStore = useFormStore()
  const globalStore = useGlobalStore()
  const { serviceTransactionId } = globalStore.startedService
  const {
    sponsoredUnifiedNumber = '',
    individualInfo: { unifiedNumber },
    applicantIdentityNumber = '',
    identityNumber = '',
    selectedCardDurationId,
    selectedApplicantClassDetailId
  } = formStore.draft.request
  const {
    module: { ICA },
    ServiceTransactions: { dubaiResidentsRenewService, renewEmiratesIDForDiplomatic },
    eidaRenewalReasons: { ResidencyRenewal }
  } = client_lookups
  const { sponsoredUN, employeeUN, administrativeRegionId } = formStore.extraMap
  const params = {
    serviceTransactionId: serviceTransactionId,
    unifiedNumber:
      sponsoredUnifiedNumber ||
      sponsoredUN ||
      unifiedNumber ||
      employeeUN ||
      administrativeRegionId,
    identityNumber: identityNumber,
    applicantIdentityNumber: applicantIdentityNumber
  }
  const res = await apiHelperService.get('/api/icaRequest/draft/getEidaDetails', { params })
  if (res) {
    const {
      enableRenewalReasons,
      allowResidentEidaRenew,
      hasCanceledOrVisaFile,
      haveDubaiFile,
      hasPendingSponsorTransFlag,
      hideReplacementDataUpdateReasonExceptDubaiResi,
      applicationRequestTypeId,
      applicantClassId,
      applicantClassDetailId,
      permitTypeId,
      isNewIdCardDurationDisabled,
      fatherUnifiedNumber,
      isIdentityNumberRequired,
      isDivorcedOrWidowedCase,
      isFoundInExceptionalList
    } = res || {}
    formStore.draft.request = {
      ...formStore.draft.request,
      fileModuleId: ICA,
      applicantClassId,
      applicantClassDetailId,
      haveDubaiFile,
      hideReplacementDataUpdateReasonExceptDubaiResi,
      hasPendingSponsorTransFlag,
      applicationRequestTypeId,
      selectedApplicantClassId: applicantClassId,
      selectedApplicantClassDetailId: applicantClassDetailId,
      permitTypeId,
      selectedisNewIdCardDurationDisabled: isNewIdCardDurationDisabled,
      fatherUnifiedNumber,
      isIdentityNumberRequired: !!isIdentityNumberRequired,
      isDivorcedOrWidowedCase: !!isDivorcedOrWidowedCase,
      selectedPendingSponsorTransFlag:
        haveDubaiFile && hasPendingSponsorTransFlag ? false : hasPendingSponsorTransFlag
    }
    formStore.draft.request.manageFields.isNewIdCardDurationDisabled = !!isNewIdCardDurationDisabled
    if ([dubaiResidentsRenewService, renewEmiratesIDForDiplomatic].includes(serviceTransactionId)) {
      if (allowResidentEidaRenew || hasCanceledOrVisaFile || hasPendingSponsorTransFlag) {
        formStore.draft.request.manageFields.isOldEidaExpiryDateDisabled = false
      }
      formStore.draft.request = {
        ...formStore.draft.request,
        hasCanceledOrVisaFile,
        allowResidentEidaRenew,
        enableRenewalReasons
      }
    }
    if (formStore.draft.request.enableRenewalReasons) {
      formStore.draft.request = {
        ...formStore.draft.request,
        applicantClassDetailId: selectedApplicantClassDetailId,
        newIdCardDurationId: selectedCardDurationId,
        eidaRenewalReasonId: ResidencyRenewal || ''
      }
    }
    if (isFoundInExceptionalList) {
      formStore.draft.request.manageFields.isOldEidaExpiryDateDisabled = false
      if (!identityNumber) {
        formStore.draft.request.manageFields.isIdentityNumberDisabled = false
      }
    }
  }
}

const use580DefaultVal = () => {
  const globalStore = useGlobalStore()
  const { serviceTransactionId } = globalStore.startedService
  if (serviceTransactionId != 580) return
  const formStore = useFormStore()
  const {
    individualInfo: { fileNumber = '' }
  } = formStore.draft.request
  const {
    uaeNationality,
    maritalStatuses: { Single },
    educationLevels: { none },
    professions: { child }
  } = client_lookups
  formStore.draft.request = {
    ...formStore.draft.request,
    countryOfBirthId: uaeNationality,
    maritalStatusId: Single,
    professionId: child,
    qualificationLevelId: none,
    fatherFileNumber: fileNumber
  }
}

const loadReCaptchaSetup = async () => {
  const formStore = useFormStore()
  const authStore = useAuthStore()
  const globalStore = useGlobalStore()
  const { enableServiceRecaptcha } = globalStore.startedService.serviceConfig
  const res = await apiHelperService.get('/api/content/getReCaptchaSetup')
  if (!res) return
  const { recaptchaTC, recaptchaEstab } = res
  if (authStore.isUserTypingCenter) {
    formStore.extraMap.enableServiceRecaptcha = enableServiceRecaptcha && recaptchaTC
  }
  if (authStore.isUserEstablishment) {
    formStore.extraMap.enableServiceRecaptcha = enableServiceRecaptcha && recaptchaEstab
  }
}
export default async function () {
  try {
    await initForm()
    await initInfo()
    await getEidaDetails()
    await use580DefaultVal()
    await loadReCaptchaSetup()
  } catch (error) {
    console.error('useIcaServicesPreload error: ', error)
  }
}
